export default __webpack_public_path__ + "static/media/endRest.3ebd75ea.mp3";